import PopupModal_V2 from '@wolffun/shared/src/Components/PopupModal_V2';
export default PopupModal_V2;